import { render, staticRenderFns } from "./Hobbiton.vue?vue&type=template&id=5fcd79b2&"
import script from "./Hobbiton.vue?vue&type=script&lang=js&"
export * from "./Hobbiton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports